import { render, staticRenderFns } from "./Appbar.vue?vue&type=template&id=96264996"
import script from "./Appbar.vue?vue&type=script&lang=js"
export * from "./Appbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports